import { createContext, useContext, useEffect, useState } from "react";
import { TpSlValueEntity } from "../modules/tp-sl-profiles/tp-sl-group";
import {
  AutoSellSetting,
  useGetBotAutoSellSetting,
} from "@api/bot/bot-get-auto-sell-setting.ts";
import { useWallet } from "@providers/wallet";
export type BuySellTokenProviderState = {
  isBuySlippageAuto: boolean;
  buySlippage: string;
  isSellSlippageAuto: boolean;
  sellSlippage: string;
  setIsBuySlippageAuto: React.Dispatch<React.SetStateAction<boolean>>;
  setBuySlippage: React.Dispatch<React.SetStateAction<string>>;
  setIsSellSlippageAuto: React.Dispatch<React.SetStateAction<boolean>>;
  setSellSlippage: React.Dispatch<React.SetStateAction<string>>;
  setTpSlValues: React.Dispatch<React.SetStateAction<TpSlValueEntity[]>>;
  tpSlValues: TpSlValueEntity[];
};

const BuySellBotTokenContext = createContext<BuySellTokenProviderState>({
  isBuySlippageAuto: true,
  buySlippage: "0",
  isSellSlippageAuto: true,
  sellSlippage: "0",
  setIsBuySlippageAuto: () => {},
  setBuySlippage: () => {},
  setIsSellSlippageAuto: () => {},
  setSellSlippage: () => {},
  setTpSlValues: () => {},
  tpSlValues: [],
});

export const useBuySellBotTokenContext = () => {
  return useContext(BuySellBotTokenContext);
};

type BuySellTokenProviderProps = {
  children: React.ReactNode;
};

const BuySellBotTokenProvider = ({ children }: BuySellTokenProviderProps) => {
  const [isBuySlippageAuto, setIsBuySlippageAuto] = useState(true);
  const [buySlippage, setBuySlippage] = useState("0");
  const [isSellSlippageAuto, setIsSellSlippageAuto] = useState(true);
  const [sellSlippage, setSellSlippage] = useState("0");
  const [tpSlValues, setTpSlValues] = useState<TpSlValueEntity[]>([
    { tpSl: "", sellBalance: "" },
  ]);
  const { userId, appPubKey } = useWallet();

  const { data: autoSellResponse } = useGetBotAutoSellSetting({
    userId,
    appPubKey,
  });

  useEffect(() => {
    if (sellSlippage !== "0") {
      setIsSellSlippageAuto(false);
    }
  }, [sellSlippage]);

  useEffect(() => {
    if (buySlippage !== "0") {
      setIsBuySlippageAuto(false);
    }
  }, [buySlippage]);

  useEffect(() => {
    let mapped = [{ tpSl: "", sellBalance: "" }];
    if (
      autoSellResponse?.autoSellSetting &&
      autoSellResponse.autoSellSetting.length > 0
    ) {
      mapped = autoSellResponse.autoSellSetting.map(
        (item: AutoSellSetting) => ({
          id: item._id,
          tpSl: item.value.toString(),
          sellBalance: (item.sellPercent ?? 0).toString(),
        }),
      );
      setTpSlValues(mapped);
    }
  }, [autoSellResponse, setTpSlValues]);

  return (
    <BuySellBotTokenContext.Provider
      value={{
        isBuySlippageAuto,
        buySlippage,
        isSellSlippageAuto,
        sellSlippage,
        setIsBuySlippageAuto,
        setBuySlippage,
        setIsSellSlippageAuto,
        setSellSlippage,
        setTpSlValues,
        tpSlValues,
      }}
    >
      {children}
    </BuySellBotTokenContext.Provider>
  );
};

export default BuySellBotTokenProvider;
